export const partnerData = [
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yNjEwNTYyOA==",
            "value": "host-sponsor",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Host Sponsor"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIxMjk1NjA=",
                "name": "Jumeirah",
                "logoUrl": "https://static.swapcard.com/public/images/f7db9c35912544dd8aabf7d17505884b.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                        "value": "Host Sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Host Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjEwNTYyOA==",
                        "value": "host-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Host Sponsor"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
            "value": "strategic-partner",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Strategic Partner"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NTM=",
                "name": "NEOM",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/02f00839db2b4b5c87f2596c203ea173.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NzY=",
                "name": "Taiba Investments",
                "logoUrl": "https://static.swapcard.com/public/images/221cb120930442dbb6a698b468e6780c.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTg4OTY=",
                "name": "Rua Al Madinah Holding Company",
                "logoUrl": "https://static.swapcard.com/public/images/57aee9f5fc0940c8b5458359ae953b10.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjg5ODU=",
                "name": "Tourism Promotions Board Philippines",
                "logoUrl": "https://static.swapcard.com/public/images/a01144b56d25483bbc7f98d87534716c.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNjY1NTg=",
                "name": "Territorial Development Agency (Albania)",
                "logoUrl": "https://static.swapcard.com/public/images/755b5b1f464d4974ada004211d828c6e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyOTI4OTk=",
                "name": "UAE Ministry of Economy & Tourism",
                "logoUrl": "https://static.swapcard.com/public/images/ea306bd68ae842eeb1a55f3b8f6592c2.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjAyNTE=",
                "name": "Egypt's Ministry of Housing, Utilities and Urban Communities (MHUC)",
                "logoUrl": "https://static.swapcard.com/public/images/6a549c3988b8483b840c493c57ef4e03.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjYzMjc=",
                "name": "New Murabba",
                "logoUrl": "https://static.swapcard.com/public/images/dc124ed25649419fb888d12ba4bb8da5.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOQ==",
                        "value": "strategic-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Strategic Partner"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yNjEwNTYxNg==",
            "value": "knowledge-partner",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Knowledge Partner "
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIxMjk0OTA=",
                "name": "PWC",
                "logoUrl": "https://static.swapcard.com/public/images/c2824e6ba2ad48179222dde27b7caf31.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNjEwNTYxNg==",
                        "value": "knowledge-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Knowledge Partner "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTY5OA==",
                        "value": "knowledge-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Knowledge Partner"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
            "value": "headline-sponsor",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Headline Sponsor"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NzA=",
                "name": "Radisson Hotel Group",
                "logoUrl": "https://static.swapcard.com/public/images/61cbc9d9864c4a4f92a07cda247fa600.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NzM=",
                "name": "Rotana Hotels and Resorts",
                "logoUrl": "https://static.swapcard.com/public/images/793f950867064ec09c696375f4a14cad.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NzQ=",
                "name": "Club Med",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/20184dd0a58a43efa904436e2e309e81.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Nzc=",
                "name": "Accor",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/fa644ca3c739455088ab2f9a34909cc7.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3ODI=",
                "name": "Red Sea Global",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/5715dc5ef8a2467e96f2ff49e1ab4a13.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTY0OTI=",
                "name": "The Ascott Limited",
                "logoUrl": "https://static.swapcard.com/public/images/49db52177b8245e79b9aea84cabdf605.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxMTAyMTk=",
                "name": "Marriott International",
                "logoUrl": "https://static.swapcard.com/public/images/336860a749474564ae57989b69eaf942.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNDA1OTQ=",
                "name": "ARADA",
                "logoUrl": "https://static.swapcard.com/public/images/270ad7d66f8049c0b76165ace2af4806.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNDA2Nzc=",
                "name": "Italia Hospitality",
                "logoUrl": "https://static.swapcard.com/public/images/a90452d09a6b49998671a333722cc3c7.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzA0ODA=",
                "name": "IHG",
                "logoUrl": "https://static.swapcard.com/public/images/2907870e16754212a31705a6ba9abfee.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzA0ODE=",
                "name": "Barrière Hotels & Resorts",
                "logoUrl": "https://static.swapcard.com/public/images/475186693c6643a492e15741a2ba62b8.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxOTU2ODk=",
                "name": "Colliers",
                "logoUrl": "https://static.swapcard.com/public/images/3f33358e54fe42b9a75a14abf965ee8e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMDQwMTE=",
                "name": "Jabal Omar Development Company",
                "logoUrl": "https://static.swapcard.com/public/images/5649a31decaf43d9a12b16b3ad5c266d.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMTgzMDM=",
                "name": "Modon Holding Hospitality",
                "logoUrl": "https://static.swapcard.com/public/images/74808361d34747aaab79b2c65e684c2e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyOA==",
                        "value": "headline-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Headline Sponsor"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
            "value": "sponsor",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Sponsor"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NjI=",
                "name": "QUO",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NjU=",
                "name": "Minor Hotels",
                "logoUrl": "https://static.swapcard.com/public/images/d3d38e9a405f40789edd1bcbd6c6ec33.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NjY=",
                "name": "Wyndham Hotels & Resorts",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/d8f0924ea9164f218a5475faabf39906.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Njg=",
                "name": "Indian Hotels Company Limited",
                "logoUrl": "https://static.swapcard.com/public/images/b431263bc8e4418b9a3d9f9ada77ed70.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Njk=",
                "name": "Knight Frank",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3NzE=",
                "name": "Aleph Hospitality",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/997d458c00fb4e458857a94e384ff447.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Nzg=",
                "name": "Compass Project Consulting",
                "logoUrl": "https://static.swapcard.com/public/images/c73f0e9e1b3046f6aa1bc17eeaf18b6c.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Nzk=",
                "name": "Legacy Hotels Holding",
                "logoUrl": "https://static.swapcard.com/public/images/9ea37d06ba0045cf8d6b99d4e016d383.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTMxNDI=",
                "name": "BWH Hotels",
                "logoUrl": "https://static.swapcard.com/public/images/7928866a5cc742928c50f9c3d258cd6b.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTY0OTc=",
                "name": "Rikas Hospitality Group",
                "logoUrl": "https://static.swapcard.com/public/images/78ef037446f543e780638b390c3033fa.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTY1MjM=",
                "name": "JLL",
                "logoUrl": "https://static.swapcard.com/public/images/e3ee5f47326244f78dde78e96841f20b.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTkxOTU=",
                "name": "EHL Hospitality Business School",
                "logoUrl": "https://static.swapcard.com/public/images/5b46999b3568472fafec7ee6e6031450.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwOTkyNDQ=",
                "name": "JT+Partners",
                "logoUrl": "https://static.swapcard.com/public/images/f6d06ff5e9e1497b99072fe4b499ba8d.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxMjkxMDk=",
                "name": "STR, a CoStar Group Company",
                "logoUrl": "https://static.swapcard.com/public/images/c8e6f43b323543e686ca58d2e569d73f.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxMzkyMjc=",
                "name": "Credibl Inc",
                "logoUrl": "https://static.swapcard.com/public/images/3cef8f82caf7446bb7595dbff925d236.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNDA2NzQ=",
                "name": "H World",
                "logoUrl": "https://static.swapcard.com/public/images/b86b631726ec41e8aba9f86fc238f208.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNDA3MDM=",
                "name": "The First Group Hospitality",
                "logoUrl": "https://static.swapcard.com/public/images/117faf988f1045edbbe75044b9cba8cd.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNjA4NTI=",
                "name": "TUI Hotels and Resorts",
                "logoUrl": "https://static.swapcard.com/public/images/ca1c29ad521c424ab5c78c6bd930b175.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNjA4NTM=",
                "name": "CBRE MENA",
                "logoUrl": "https://static.swapcard.com/public/images/466d0b1855de46bc981af569b5e1c6d1.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNjA4NTQ=",
                "name": "United Hospitality Management",
                "logoUrl": "https://static.swapcard.com/public/images/377dfc65e9e245ed81e4c87952a347fe.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzA3MDI=",
                "name": "Forsite Creative",
                "logoUrl": "https://static.swapcard.com/public/images/0504bb12335d402ea9a1095d83902932.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMTU2MTM=",
                "name": "UNS United Network Studio",
                "logoUrl": "https://static.swapcard.com/public/images/b1fb535b61d2443fb1664f0a082e9c5f.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjI3NTk=",
                "name": "Action Hotels Company",
                "logoUrl": "https://static.swapcard.com/public/images/7ce752f22e6b44bfa436af7e97fcf485.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjI3NjE=",
                "name": "Enterprise Greece",
                "logoUrl": "https://static.swapcard.com/public/images/cefa83269f904c48bc3e726cbf2cc040.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjI3NjI=",
                "name": "Blastness",
                "logoUrl": "https://static.swapcard.com/public/images/5ccdccc523524700b290c7ba0ddf1d9e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzg0ODI=",
                "name": "Aristara",
                "logoUrl": "https://static.swapcard.com/public/images/7bc9fbb44ad54e3988e2d50ce0062e2a.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNDA3OTE=",
                "name": "Bushtec Creations",
                "logoUrl": "https://static.swapcard.com/public/images/b923d2a6ea5c4b2f836e5cc12b39a855.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNTA2MzY=",
                "name": "Technogym",
                "logoUrl": "https://static.swapcard.com/public/images/cd786dea49124b4b957e311328e79257.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNjE5NjM=",
                "name": "HDL",
                "logoUrl": "https://static.swapcard.com/public/images/114cef68ab7f42f4841b40e2828e72f1.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNjg0NDQ=",
                "name": "Arthur D Little",
                "logoUrl": "https://static.swapcard.com/public/images/b6236d986b644de8b406ced506f9d0f3.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNzU2NzA=",
                "name": "Parsons",
                "logoUrl": "https://static.swapcard.com/public/images/b334949041e0477f8b5648f8b1fbb987.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNzk2MTI=",
                "name": "ELKO EP",
                "logoUrl": "https://static.swapcard.com/public/images/7cee8dfe6e0d47429841d6f2781a3b9c.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyODA5ODM=",
                "name": "Sharjah Investment and Development Authority (Shurooq)",
                "logoUrl": "https://static.swapcard.com/public/images/cf7dc9326cfe4215aac48d940b99cdf4.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMDQ1OTU=",
                "name": "Abu Dhabi Hospitality Academy - Les Roches",
                "logoUrl": "https://static.swapcard.com/public/images/9a8ff0e42c874f4d802f771adeaca4ae.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMTgzMDQ=",
                "name": "Millat Group",
                "logoUrl": "https://static.swapcard.com/public/images/9412b269b8724d2d9e6e8baea712ba3a.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjA4NzE=",
                "name": "Danube Hospitality",
                "logoUrl": "https://static.swapcard.com/public/images/43fcf8af183b4c099d0871fc71a7d797.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjM3NzY=",
                "name": "Hyatt",
                "logoUrl": "https://static.swapcard.com/public/images/ae8117fab9114456981eaac921be2efa.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjYzNTc=",
                "name": "Baccarat Hotel & Residences Maldives",
                "logoUrl": "https://static.swapcard.com/public/images/82687e126dc44a888773978d078722c1.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjY5MjA=",
                "name": "FSK & Partners",
                "logoUrl": "https://static.swapcard.com/public/images/df8aada28c4949b8a4c9eb7b063df8a0.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjY5MzE=",
                "name": "Ayana Holding",
                "logoUrl": "https://static.swapcard.com/public/images/8f02db5eab3e4f4eaf44f8be2da2789e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjcxMDk=",
                "name": "ALAIN",
                "logoUrl": "https://static.swapcard.com/public/images/d2d15d99841f49409c6d14a2466402a3.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcyNw==",
                        "value": "sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Sponsor"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
            "value": "exhibitor",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Exhibitors"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3Njc=",
                "name": "Rove Hotels",
                "logoUrl": "https://cdn-api.swapcard.com/public/images/d2c1487560c3423fb490d96cb471da87.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3ODE=",
                "name": "ARK People Solutions",
                "logoUrl": "https://static.swapcard.com/public/images/047f55dacb7a4ca882bfa00fadd9735d.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIwNjQ3ODM=",
                "name": "Shaza Hotels",
                "logoUrl": "https://static.swapcard.com/public/images/7531f54bcfd24a47af4833191968f34f.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNDA3MDY=",
                "name": "Centara Hotels & Resorts",
                "logoUrl": "https://static.swapcard.com/public/images/f99a5ac6d9ff4bc9aeb8e1a789606311.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzE5NzY=",
                "name": "Cavendish Maxwell",
                "logoUrl": "https://static.swapcard.com/public/images/4078f6d3e19a442abe5f60954c0ed43f.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzc5MDc=",
                "name": "Start Reverse",
                "logoUrl": "https://static.swapcard.com/public/images/2cd3acd337584a2a91fe55b30c00dbd6.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNzk2MTM=",
                "name": "Inntelo AI",
                "logoUrl": "https://static.swapcard.com/public/images/c95bd6775e274b0694f0844e4a101373.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMDE1NDE=",
                "name": "Invest Cyprus",
                "logoUrl": "https://static.swapcard.com/public/images/cf927bf6dcbc496e8e3ba50aef17da26.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMTMzNzk=",
                "name": "iReserved",
                "logoUrl": "https://static.swapcard.com/public/images/f30fe38641684dff8b30b1c07e935f97.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjM3Mjg=",
                "name": "DigiValet",
                "logoUrl": "https://static.swapcard.com/public/images/b733a9ca6e1f46a98760000e175a812a.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNTg5NzkyNg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitors"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwMg==",
                        "value": "exhibitor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Exhibitor"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
            "value": "tech-pavilion",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Tech Pavilion"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIyMjg5OTU=",
                "name": "ExploreTECH",
                "logoUrl": "https://static.swapcard.com/public/images/43d7215ea33d4f618cf700c8a33146f1.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjg5OTY=",
                "name": "FLYR",
                "logoUrl": "https://static.swapcard.com/public/images/464928a75b704d79b4289de1ea3a3a54.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjg5OTc=",
                "name": "Portal",
                "logoUrl": "https://static.swapcard.com/public/images/04eeda624a4749439440e6a740b20873.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMjg5OTg=",
                "name": "dailypoint",
                "logoUrl": "https://static.swapcard.com/public/images/9f93fd0964eb414cbc49d93aa38b5a67.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzcwMjc=",
                "name": "RMS Cloud",
                "logoUrl": "https://static.swapcard.com/public/images/b0f1b60699f94cc49c370feef87eaf89.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNzgzNzg=",
                "name": "Fairmas",
                "logoUrl": "https://static.swapcard.com/public/images/134ffe41ce384ec8835bee7e1fda1605.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNzgzNzk=",
                "name": "Adyen",
                "logoUrl": "https://static.swapcard.com/public/images/206de47a4fb8478d8b408cfcd082bd4e.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMDQ4MjA=",
                "name": "ROOMNET",
                "logoUrl": "https://static.swapcard.com/public/images/5aec4e636c4943519083269e46c2499d.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjQzMDQ=",
                "name": "Inhabitr",
                "logoUrl": "https://static.swapcard.com/public/images/b043a0a9c61f4991ad97045b2040d480.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjQzMTM=",
                "name": "Qonterra",
                "logoUrl": "https://static.swapcard.com/public/images/6f562f1465d248f891fdd814dcb40395.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNzc0MTg0MA==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTcwNQ==",
                        "value": "tech-pavilion",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Tech Pavilion"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yODc1NTU5MA==",
            "value": "startup-sponsor",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Startup Sponsor"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIzMjU1MzQ=",
                "name": "Treema AI",
                "logoUrl": "https://static.swapcard.com/public/images/7ec1fdc350a747149c8069757b99a75d.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yODc1NTU4Nw==",
                        "value": "startup-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Startup Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODc1NTU5MA==",
                        "value": "startup-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Startup Sponsor"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjU1MzY=",
                "name": "Rook AI",
                "logoUrl": "https://static.swapcard.com/public/images/b5025100009f40bf813a52047a1b6975.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yODc1NTU4Nw==",
                        "value": "startup-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Startup Sponsor"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODc1NTU5MA==",
                        "value": "startup-sponsor",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Startup Sponsor"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
            "value": "supporter",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Supporters"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIxNzEzNDk=",
                "name": "World Sustainable Hospitality Alliance",
                "logoUrl": "https://static.swapcard.com/public/images/a8a80d1c4f2345968e19c9df09d93512.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzEzNTA=",
                "name": "UN Tourism",
                "logoUrl": "https://static.swapcard.com/public/images/8d1f97b7d7e54f8dad09130ceb4aeb7b.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxNzEzNTI=",
                "name": "World Travel & Tourism Council",
                "logoUrl": "https://static.swapcard.com/public/images/0076c0ff74f34971b4ab579389f5b7f8.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIxOTQyNTM=",
                "name": "World Sustainable Travel & Hospitality Awards",
                "logoUrl": "https://static.swapcard.com/public/images/b44e2f1f5f644171982602d4e46c09fe.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMDIyNDE=",
                "name": "Emirates",
                "logoUrl": "https://static.swapcard.com/public/images/c7411fb1c9b84a87a88e4ae1ec309a38.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMTgyOTk=",
                "name": "QE 2 Hospitality Academy FZE - Jafza",
                "logoUrl": "https://static.swapcard.com/public/images/c4049b3ecaff48519da0a9877b7c630a.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporter"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjYwODI=",
                "name": "VOXO",
                "logoUrl": "https://static.swapcard.com/public/images/10f09017019b48c8839ed7b3f85627dd.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNjY5MzQ2NQ==",
                        "value": "supporter",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Supporters"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "group": {
            "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
            "value": "media-partner",
            "translations": [
                {
                    "language": "en_US",
                    "value": "Media Partner"
                }
            ]
        },
        "partners": [
            {
                "id": "RXhoaWJpdG9yXzIxODgwNjM=",
                "name": "Travel and Tour World",
                "logoUrl": "https://static.swapcard.com/public/images/8426b8b724524606bf0157b18d988578.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzMxMzQ=",
                "name": "Integrator Media",
                "logoUrl": "https://static.swapcard.com/public/images/572edd7f35414b45a7edf8233ee2a4e0.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzMxMzU=",
                "name": "Finance World",
                "logoUrl": "https://static.swapcard.com/public/images/2bed07ba0c30411fbe8c5f57f864731a.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzMxMzY=",
                "name": "HospitalityNews",
                "logoUrl": "https://static.swapcard.com/public/images/28fb08045c0548c394f8ae1b63e28974.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyMzMxMzc=",
                "name": "HospitalityNet",
                "logoUrl": "https://static.swapcard.com/public/images/5b7bfe276880412f81de015014141d78.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNDA2OTg=",
                "name": "Hozpitality",
                "logoUrl": "https://static.swapcard.com/public/images/28820731891f4602ac645a8647dfe8c1.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyNjYxMjI=",
                "name": "Hotel & Catering",
                "logoUrl": "https://static.swapcard.com/public/images/49d1861734d14afaa2eba06863c389d7.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyODMwNzM=",
                "name": "Franchising.sa",
                "logoUrl": "https://static.swapcard.com/public/images/c7596fb31ba94429a3456bc0fd4a8e51.jpeg",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyODM3OTY=",
                "name": "TTN Worldwide",
                "logoUrl": "https://static.swapcard.com/public/images/a909339cfeec4f4da3db70943a604b0b.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIyOTAyOTg=",
                "name": "BRESI",
                "logoUrl": "https://static.swapcard.com/public/images/d3abc687958345e6891e9beb929a67bb.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "RXhoaWJpdG9yXzIzMjYwOTA=",
                "name": "TravTalk",
                "logoUrl": "https://static.swapcard.com/public/images/50c88aadb967453c934e585cbf38f546.png",
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yODY1NTczMA==",
                        "value": "media-partner",
                        "definition": {
                            "id": "RmllbGREZWZpbml0aW9uXzc4MjgzNw==",
                            "name": "Type"
                        },
                        "translations": [
                            {
                                "value": "Media Partner"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]


export const flags = [
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "271614",
        "country": "Albania Pavilion",
        "body": "<p>The Albanian Pavilion invites you to explore the country as one would pause at a record station, with an open mind, an open heart, and the curiosity to discover the unexpected. Each “record” reveals a different layer of Albania: from ancient heritage and dramatic landscapes to contemporary developments and new projects still in the making, composing a dynamic symphony of projects, spaces, and experiences that together capture the spirit, creativity, and enduring warmth of Albania’s hospitality.</p>\n<p>In recent years, Albania’s voice has grown louder. International arrivals surged from 3 million in 2020 to 11.7 million in 2024, and with projections of 15 million in 2025.</p>\n<p>Guided by the National Tourism Strategy 2025–2030, the country is shifting from seasonal, low-cost tourism toward a high-value, all-season economy rooted in authenticity, sustainability, and diversification.<br /></p>\n<p>Here we present the new wave of creativity shaping Albania’s future. Like an unreleased collection, hundreds of new “tracks” are being composed by innovative minds from around the world. In this pavilion are featured some of the most distinguished development and hospitality projects, all with strategic importance and spectacular natural backdrops.</p>\n<p>The government has emphasized its strong commitment to opening the country to investment in tourism, offering fiscal incentives, easing regulations, and actively promoting public–private partnerships. This commitment is reinforced through large-scale infrastructure investments: new airports and expanded ports, modern marinas, a rapidly improving road network, and fresh investments in rail connections and sustainable energy. Together, these initiatives position Albania as one of the Mediterranean’s most dynamic and promising destinations for sustainable tourism and hospitality development.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "281743",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/albania-the-beautiful-pyramid-of-tirana-in-the-center.jpg"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "271293",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/albania.png"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "280681",
                "groupHeading": "Presented by:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "280653",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/Soundscapes_of_Albania_Red_Black.png"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "275933",
        "country": "Cyprus Pavilion",
        "body": "<p>Cyprus continues to strengthen its standing as a premier Mediterranean destination, building on its record-breaking momentum in tourism and hospitality. In 2024, the island achieved a 5.1% increase in tourist arrivals and a 7.3% rise in revenues, while 2025 is already outperforming expectations with arrivals up by 10.4% and tourism revenues growing by 21.3% year-on-year. This sustained growth reflects rising demand from key, supported by higher visitor spending and longer stays.</p>\n<p>At FHS World 2025, the Cyprus Pavilion, presented by Invest Cyprus, will showcase how the island’s unique blend of heritage, natural beauty, and strategic location is creating diverse opportunities for investors. From luxury resorts and year-round tourism infrastructure to cultural and experiential travel ventures inspired by the island’s rich history, Cyprus offers a secure, high-growth environment for hospitality investments, backed by a pro-business framework and a dynamic vision for the future of Mediterranean tourism.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "277225",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/CyprusNissiBeach.jpg"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "275930",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/cyprus-flag.webp"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "275934",
                "groupHeading": "Presented by:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "275927",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/invest-cyprus.jpg"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "280682",
        "country": "Egypt Pavilion",
        "body": "<p>Egypt is experiencing powerful momentum in tourism and hospitality, powered by world‑renowned cultural icons in Cairo–Giza and sustained demand across Red Sea destinations such as Sharm El Sheikh and Hurghada. With the much‑anticipated Grand Egyptian Museum set to elevate Cairo’s global appeal and a robust pipeline of new hotels and mixed‑use districts, the country is expanding capacity and enhancing visitor experiences across heritage and resort markets.</p>\n<p>At FHS World 2025, the Egypt Pavilion - presented by the Ministry of Housing, Utilities and Urban Communities (MHUC) - will spotlight flagship urban development programs, waterfront resort districts, and investment‑ready hospitality opportunities. Delegates will gain insights into master‑planned destinations, infrastructure upgrades, and partnerships advancing sustainable, year‑round tourism growth.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "280656",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/egypt-pavilion.jpg"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "280677",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/egypt-flag.jpeg"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "280683",
                "groupHeading": "Presented by:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "280673",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/egypt-mhuuc.png"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "275989",
        "country": "Greece Pavilion",
        "body": "<p>Greece continues to strengthen its position as one of the world’s top tourism destinations, with over 40 million visitors welcomed in 2024 and tourism revenues reaching €21.6 billion. In 2025, Greece is seeing sustained growth driven by increased demand for luxury, cultural, and immersive travel experiences from key markets including Germany, the UK, and the US. Investments in infrastructure, expanding airline capacity, and diversification into year-round tourism are shaping a promising future for the Greek hospitality sector.</p>\n<p>At FHS World 2025, the Greece Pavilion, presented by Enterprise Greece, will showcase the nation’s vibrant tourism industry, innovative projects, and investment opportunities, inviting delegates to explore Greece’s unique blend of natural beauty, history, and modern hospitality excellence.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "275974",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/greece-pavilion-page.jpg"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "275972",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/greece-flag.png"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "275990",
                "groupHeading": "Presented by:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "275984",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/enterprise-greece-logo.png"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "271548",
        "country": "Italy Pavilion",
        "body": "<p>Italy, the world’s 5th most visited country and Europe’s most trending destination, is a premier hub for hospitality investment. At FHS World 2025, the Italy Pavilion, sponsored by Italia Hospitality, will present a curated portfolio of opportunities, including luxury resorts in iconic and emerging destinations, thermal and longevity projects driving wellbeing tourism, and investment opportunities within the National Tourism Fund.</p>\n<ul><li>Branded residences concepts of the future presented through the vision of an iconic Italian design firm</li><li>Italy’s hospitality landscape blends culture, innovation, and design excellence, creating long-term value for visionary investors.</li></ul><p>In addition, Blastness will host a dedicated area to showcase cutting-edge technology solutions for the hospitality industry, reinforcing Italy’s leadership in innovation and digital transformation.<br /></p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "265614",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/italy-pavilion-retouch.jpg"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "257285",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/flag-of-italy.png"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "271549",
                "groupHeading": null,
                "logos": [
                    {
                        "__typename": "contentLibrary_Asset",
                        "id": "217762",
                        "url": "https://cms.thebench.com/assets/content-library/img/FHS-World/Blastness_logo_basic_2020.png"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "276493",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/CPD-SGR-logo.jpg"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "276494",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/ENIT-SPA.jpg"
                    },
                    {
                        "__typename": "contentLibrary_Asset",
                        "id": "157517",
                        "url": "https://cms.thebench.com/assets/content-library/img/Italia-Hospitaliti-Logo-2020-small.png"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "276495",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/RES.png"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "277756",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/pininfarina.png"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "271583",
        "country": "Philippines Pavilion",
        "body": "<p>The Philippines, an archipelago of over 7,000 islands, is fast emerging as one of Asia's most exciting tourism and hospitality markets. With its breathtaking natural landscapes, vibrant culture, and rapidly expanding infrastructure, the country is attracting growing interest from global investors, developers, and travellers alike.</p>\n<p>At FHS World 2025, the Philippines Pavilion, presented by the Tourism Promotions Board Philippines and key industry stakeholders, will spotlight the nation's strategic push to elevate its hospitality and tourism offerings. From luxury resorts to sustainable developments, the pavilion will showcase upcoming projects and investment opportunities that highlight the Philippines' commitment to becoming a premier destination in the region.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "271574",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/philippines.webp"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "263710",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/flag-of-philippines.jpg"
            }
        ],
        "logoGroup": [
            {
                "__typename": "logoGroup_BlockType",
                "id": "271584",
                "groupHeading": "Presented by:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "263862",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/philippines-tourism.png"
                    }
                ]
            },
            {
                "__typename": "logoGroup_BlockType",
                "id": "278401",
                "groupHeading": "Partners:",
                "logos": [
                    {
                        "__typename": "site_Asset",
                        "id": "278395",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/ALH-logo.png"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "278396",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/MHR-logo.jpg"
                    },
                    {
                        "__typename": "site_Asset",
                        "id": "278398",
                        "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/RHR-logo.png"
                    }
                ]
            }
        ]
    },
    {
        "__typename": "countryPavilions_pavilion_BlockType",
        "id": "277758",
        "country": "UAE Pavilion",
        "body": "<p>The United Arab Emirates continues to be a powerhouse in global tourism, with visitor numbers steadily rising and economic contributions reaching record highs. In the first half of 2025, Dubai welcomed nearly 10 million international visitors, marking a 6% increase year-on-year, while Abu Dhabi and other emirates also recorded strong growth. The UAE's travel and tourism sector contributes nearly 13% to the national GDP, supporting over 925,000 jobs and driving innovation through world-class infrastructure, smart city initiatives, and visionary hospitality projects.</p>\n<p>At FHS World 2025, UAE will showcase the nation's relentless commitment to creating a future-ready and sustainable tourism ecosystem. Delegates will have the opportunity to explore the UAE's diverse cultural offerings, luxury developments, and groundbreaking hospitality projects that continue to propel the country as a leading global destination.</p>",
        "hero": [
            {
                "__typename": "site_Asset",
                "id": "277752",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/united-arab-emirates-pavilion.webp"
            }
        ],
        "flag": [
            {
                "__typename": "site_Asset",
                "id": "277754",
                "url": "https://cms.thebench.com/assets/img/site/FHS-World/pavilions/united-arab-emirates-flag.jpg"
            }
        ],
        "logoGroup": []
    }
]